import React, { useState } from 'react';
import { Users, FileText, AlertTriangle } from 'lucide-react';
import { MorningCheckin } from '../../../components/foreman/MorningCheckin';
import { EveningReportWizard } from '../../../components/foreman/EveningReportWizard';
import { DowntimeLog } from '../../../components/foreman/DowntimeLog';

export const ForemanModule: React.FC = () => {
  const [activeSubTab, setActiveSubTab] = useState<'checkin' | 'report' | 'downtimes'>('checkin');

  return (
    <div className="space-y-6">
      {/* Sub navigation buttons (Mobile-First Light Fintech Responsive Tab Bar) */}
      <div className="flex bg-white p-1.5 rounded-2xl border border-slate-200/90 max-w-xl mx-auto shadow-sm gap-1.5">
        <button
          type="button"
          onClick={() => setActiveSubTab('checkin')}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-xl text-xs sm:text-sm font-semibold transition active:scale-95 ${
            activeSubTab === 'checkin'
              ? 'bg-amber-500 text-slate-950 shadow-md shadow-amber-500/20 font-extrabold'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
          }`}
        >
          <Users className="w-4 h-4" />
          <span>1. Утренний чек-ин</span>
        </button>

        <button
          type="button"
          onClick={() => setActiveSubTab('report')}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-xl text-xs sm:text-sm font-semibold transition active:scale-95 ${
            activeSubTab === 'report'
              ? 'bg-blue-600 text-white shadow-md shadow-blue-600/20 font-extrabold'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
          }`}
        >
          <FileText className="w-4 h-4" />
          <span>2. Вечерний рапорт</span>
        </button>

        <button
          type="button"
          onClick={() => setActiveSubTab('downtimes')}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-xl text-xs sm:text-sm font-semibold transition active:scale-95 ${
            activeSubTab === 'downtimes'
              ? 'bg-rose-600 text-white shadow-md shadow-rose-600/20 font-extrabold'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
          }`}
        >
          <AlertTriangle className="w-4 h-4" />
          <span>3. Журнал простоев</span>
        </button>
      </div>

      {/* Subtab Content Modules */}
      {activeSubTab === 'checkin' && <MorningCheckin />}
      {activeSubTab === 'report' && <EveningReportWizard />}
      {activeSubTab === 'downtimes' && <DowntimeLog />}
    </div>
  );
};

export default ForemanModule;
